import {
    type GetAllCompanyRequestsResponseType,
    type GetAllCompanyRequestsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllCompanyUpdateRequests = async (
    params: GetAllCompanyRequestsRequestType
): Promise<GetAllCompanyRequestsResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllCompanyUpdateRequests?${queryStr}` : "/request/getAllCompanyUpdateRequests";

    return await request<GetAllCompanyRequestsResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllCompanyUpdateRequests;
